import apiClient from '../api';

export async function getMatchDay(matchDayId) {
    const { data } = await apiClient.get(`/matchdays/${matchDayId}`);
    return data;
}

export async function getAvailablePlayersForMatchDay(matchDayId) {
    const { data } = await apiClient.get(`/player-match-day/${matchDayId}/available-players`);
    return data;
}

export async function updatePlayerAvailability(playerId, matchDayId, availability) {
    const { data } = await apiClient.put(
        `/player-match-day/players/${playerId}/matchdays/${matchDayId}/availability`,
        { availability }
    );
    return data;
}

export async function removePlayerAvailability(playerId, matchDayId) {
    await apiClient.delete(`/player-match-day/players/${playerId}/matchdays/${matchDayId}/availability`);
}

export async function markPlayerAsPlayed(playerMatchDayId) {
    await apiClient.post(`/player-match-day/${playerMatchDayId}/played`);
}

export async function recordPlayerPoints(playerMatchDayId, points) {
    await apiClient.post(`/player-match-day/${playerMatchDayId}/points`, { points });
}

export async function createMatchDay(matchDay) {
    const { data } = await apiClient.post('/matchdays', matchDay);
    return data;
}

export async function updateMatchDay(matchDayId, matchDay) {
    const { data } = await apiClient.put(`/matchdays/${matchDayId}`, matchDay);
    return data;
}

export async function confirmMatchDay(matchDayId, confirmedPlayerIds, playedPlayerIds, reservePlayerIds, winningPlayerIds) {
    await apiClient.post(`/player-match-day/${matchDayId}/confirm`, { confirmedPlayerIds, playedPlayerIds, reservePlayerIds, winningPlayerIds });
}

export async function sendConvocationEmails(matchDayId, playerIds) {
    await apiClient.post(`/player-match-day/${matchDayId}/notify`, playerIds);
}

export async function confirmWinners(matchDayId, winningPlayerIds) {
    const { data } = await apiClient.post(`/player-match-day/${matchDayId}/results`, winningPlayerIds );
    return data;
}

export async function deleteMatchDay(matchDayId) {
    await apiClient.delete(`/matchdays/${matchDayId}`);
}

export async function saveCourtResults(matchDayId, courtResults) {
    // courtResults: [{ courtNumber, set1Team, set1Opponent, set2Team, set2Opponent, set3Team, set3Opponent }]
    const { data } = await apiClient.post(`/matchdays/${matchDayId}/court-results`, courtResults);
    return data;
}

export async function getCourtResults(matchDayId) {
    const { data } = await apiClient.get(`/matchdays/${matchDayId}/court-results`);
    return data;
}